const BottomUpType = {
  GETDATA: 'GETDATA',
  CHANNELINFO_MODAL: 'CHANNELINFO_MODAL',
  EDIT_CHANNEL_DATA: 'EDIT_CHANNEL_DATA',
  GET_CHANNEL_LIST: 'GET_CHANNEL_LIST',
  GET_ACTIVE_CHANNEL_LIST: 'GET_ACTIVE_CHANNEL_LIST',
  LOADER: 'LOADER',
  CLEAR_PLANNING_BOTTOM_DATA: 'CLEAR_PLANNING_BOTTOM_DATA',
};

export default BottomUpType;
